export const fncEmptyBranches = (state, payload) => {
	state.branchList = [];
}

export const setBranchList = (state, payload) => {
	state.branchList = payload;
}

export const setObjBranchEdit = (state, payload) => {
	for ( var k in payload.data ) {
		if( payload.data[k].branchId == payload.branchId ) {
			state.objBranchEdit = payload.data[k];
			state.objBranchEdit.regionObj = payload.regions
			state.branchLogo = payload.data[k].logo;
		}
	}
	for (var c in state.objBranchEdit.regionObj) {
		if (state.objBranchEdit.regions.indexOf(state.objBranchEdit.regionObj[c].loc_id) > -1) {
			state.objBranchEdit.regionObj[c].selected = true;
		}
		for (var p in state.objBranchEdit.regionObj[c].children) {
			if (state.objBranchEdit.regions.indexOf(state.objBranchEdit.regionObj[c].children[p].loc_id)  > -1) {
				state.objBranchEdit.regionObj[c].children[p].selected = true;
			}
			for (var t in state.objBranchEdit.regionObj[c].children[p].children) {
				if (state.objBranchEdit.regions.indexOf(state.objBranchEdit.regionObj[c].children[p].children[t].loc_id)  > -1) {
					state.objBranchEdit.regionObj[c].children[p].children[t].selected = true
				}
			}
		}
	}
	state.userRegions = state.objBranchEdit.regionObj;
}

export const setBranchLogo = (state, payload) => {
	state.branchLogo = payload;
}
